module.exports = __webpack_public_path__ + "static/media/tas-gov_bw.34767eac.svg";